import { Button } from '@/components/ui/button';

type NavigationBarProps = {
  onNext: () => void;
  label: string;
  loading?: boolean;
  transparent?: boolean;
  disabled?: boolean;
};

export const NavigationBar = ({
  onNext,
  label = 'Continuer',
  loading,
  transparent,
  disabled,
}: NavigationBarProps) => (
  <div className="flex flex-row items-center justify-center mt-5 mb-2.5 mmh48:mb-0 w-full mx-6 nsm:mx-0">
    <Button
      type="submit"
      variant={transparent ? 'ctaSecondary' : 'ctaPrimary'}
      size="lg"
      className="nmd:min-h-13 nmd:w-82.5"
      disabled={!!loading || !!disabled}
      onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
        if (!loading) {
          e.preventDefault();
          onNext();
        }
      }}
    >
      {label}
    </Button>
  </div>
);
